/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Split_DescInputs */

const en_pc_online_task_split_desc = /** @type {(inputs: Pc_Online_Task_Split_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Organize pages, select pages and extract them into a new document. Split document cuts a file every n pages or before the pages you choose.`)
};

const zh_pc_online_task_split_desc = /** @type {(inputs: Pc_Online_Task_Split_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Organize pages 中选中页面，把它们提取为新文档。Split document 可以每隔 n 页拆分，或在你选择的页面之前拆分。`)
};

/**
* | output |
* | --- |
* | "In Organize pages, select pages and extract them into a new document. Split document cuts a file every n pages or before the pages you choose." |
*
* @param {Pc_Online_Task_Split_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_split_desc = /** @type {((inputs?: Pc_Online_Task_Split_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Split_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_split_desc(inputs)
	return zh_pc_online_task_split_desc(inputs)
});
export { pc_online_task_split_desc as "pc.online.task.split.desc" }